import Spacer from '@antimatterhq/ui/components/spacer';
import { cn } from '@antimatterhq/ui/lib/utils';
import { Icon } from '@antimatterhq/ui/components/icon';
import { Link, Text } from '@antimatterhq/ui/components/typography';
import { Button } from '@antimatterhq/ui/components/button';

interface GlobalErrorProps {
  isRetryable?: boolean;
  retryText?: string;
  learnMoreLink?: string;
  learnMoreText?: string;
  title?: string;
  description?: string | React.ReactNode;
  onRetry?: () => Promise<void>;
  className?: string;
  iconSize?: 'xs' | 'sm' | 'md' | 'lg';
  'data-testid'?: string;
}

export const GlobalError: React.FunctionComponent<GlobalErrorProps> = ({
  onRetry,
  isRetryable = true,
  retryText = 'Retry',
  learnMoreLink,
  learnMoreText,
  title,
  description,
  className,
  iconSize = 'md',
  'data-testid': dataTestId,
}) => {
  return (
    <div
      className={cn(
        'flex h-full w-full flex-col items-center justify-center',
        className,
      )}
      data-testid={dataTestId}
    >
      <Icon
        icon="lucide:octagon-alert"
        className={cn(
          'text-gray-300',
          iconSize === 'xs' && 'h-12 w-12',
          iconSize === 'sm' && 'h-16 w-16',
          iconSize === 'md' && 'h-24 w-24',
          iconSize === 'lg' && 'h-32 w-32',
        )}
      />
      <Spacer size="lg" />
      <Text size="lg" semiBold className="text-gray-500">
        {title}
      </Text>
      {typeof description === 'string' ? (
        <Text className="text-gray-500">{description}</Text>
      ) : (
        description
      )}
      {learnMoreLink && learnMoreText && (
        <Link to={learnMoreLink}>{learnMoreText}</Link>
      )}
      {isRetryable && (
        <>
          <Spacer size="lg" />
          <Button onClick={onRetry}>{retryText}</Button>
        </>
      )}
    </div>
  );
};
